module.exports = __webpack_public_path__ + "img/bonus.cd9f67d6.svg";